module.exports = __webpack_public_path__ + "img/spark.f84dc574.svg";